import React from "react";
import { Link } from "react-router-dom";
import './index.css';
//import {ImageUpload} from '../Utils/ImageUpload';
import InputMask from 'react-input-mask';



const onlyNumbers = (str) => str.replace(/[^0-9]/g, '')
function formatLeadingZero(text) {
  if (text.length === 13) {
    return `0${text}`;
  } else
    if (parseInt(text) < 100) {
      return `0${text}`;
    } else {
      return `${text}`;
    }
}


const MaskedInput = ({ value, onChange, name, mask, className }) => {
    function handleChange(event) {
      onChange({
        ...event,
        className,
        target: {
          ...event.target,
          name,
          value: onlyNumbers(event.target.value),
        }
      });
    };

    return (
      <InputMask
        name={name}
        mask={mask}
        value={value}
        onChange={handleChange}
        className="form-control fontmenor texto_centro"
        id="exampleInputcnpj"
        aria-describedby="emailHelp"
        disabled
      />
    );
  };


function ocultarBotao(){
    


}

function CardLista(props) {
    return (
        <form className="form-control" style={{backgroundColor: props.cor}}>
            <div className="row">  
              <div className="col-xl-12 col-lg-12 col-sm-12 col-12">
                <label className="form-label">Nome</label>
                { props.nome ===null ? <input type="text"  value="SEM SUPERCLUBE **Inapto**" className="form-control fontmenor" id="vlnome" aria-describedby="nome" disabled />
                                   : <input type="text"  value={props.nome} className="form-control fontmenor" id="vlnome" aria-describedby="nome" disabled />

                }
                
              </div>

              <div className="col-xl-4 col-lg-4 col-sm-4 col-4">
                <label className="form-label">CPF</label>
                <input type="text"  value={props.cpf} className="form-control fontmenor " id="vlcpf" aria-describedby="cpf" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-sm-4 col-4">
                <label className="form-label "> Bairro</label>
                <input type="text"  value={props.bairro} className="form-control fontmenor " id="vlbairro" aria-describedby="bairro" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-sm-4 col-4">
                <label className="form-label "> Cidade</label>
                <input type="text"  value={props.cidade} className="form-control fontmenor " id="vlcidade" aria-describedby="cidade" disabled />
              </div>


              <div className="col-xl-4 col-lg-4 col-sm-4 col-4">
                <label className="form-label">Cupons</label>
                <input type="text"  value={props.cupons}  className="form-control fontmenor esquerda" id="vlcupom" aria-describedby="cupom" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-sm-4 col-4">
                <label className="form-label"><i className="fa fa-usd"></i> Compras</label>
                <input type="text"  value={props.compras}  className="form-control fontmenor esquerda" id="vlcompras" aria-describedby="compras" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-sm-4 col-4">
                <label className="form-label "><i className="fa fa-money"></i> Descontos</label>
                <input type="text"  value={props.descontos} className="form-control fontmenor esquerda vermelho" id="vldescontos" aria-describedby="descontos" disabled />
              </div>
            </div>
            <div>
                {props.statusfunc==="A" ? <label className="form-label vermelho"><i className="fa fa-circle"></i> Ativo</label>
                                       : <label className="form-label vermelho"><i className="fa fa-circle-o"></i> Inativo</label>
                }
            </div>
          </form>
          
    );
}

export default CardLista;